import { render, staticRenderFns } from "./CommandeHistorique.vue?vue&type=template&id=083ef18c&"
import script from "./CommandeHistorique.vue?vue&type=script&lang=ts&"
export * from "./CommandeHistorique.vue?vue&type=script&lang=ts&"
import style0 from "./CommandeHistorique.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports